import { useContext } from 'react'
import { NavLink } from 'react-router-dom'

import { UserContext } from '../../contexts/UserContext'
import { isPF } from '../../api/auth/auth'

import { isPromotor } from './sideMenuUtils'

import * as S from './styles'

const ProfileSideMenu = () => {
  const { user } = useContext(UserContext)

  return (
    <S.Wrapper className="col-3">
      <S.ProfileMenu className="perfil-menu">
        <S.ProfileBox className="perfil-box">
          <S.ProfileMenuList className="perfil-menu-list">
            <S.ProfileMenuItem className="perfil-menu-item">
              <NavLink
                activeClassName="_is-active"
                exact
                to="/meu-perfil"
                className="perfil-menu-item-link "
              >
                Dados de Cadastro
              </NavLink>
            </S.ProfileMenuItem>
            <S.ProfileMenuItem className="perfil-menu-item">
              <NavLink
                activeClassName="_is-active"
                to="/meus-pedidos"
                className="perfil-menu-item-link "
              >
                Meus Pedidos
              </NavLink>
            </S.ProfileMenuItem>
            <S.ProfileMenuItem className="perfil-menu-item">
              <a
                href={`${process.env.REACT_APP_URL_MAIN}/meuperfil/minhalista`}
                className="perfil-menu-item-link"
              >
                Minhas Listas
              </a>
            </S.ProfileMenuItem>
            <S.ProfileMenuItem className="perfil-menu-item">
              <NavLink
                activeClassName="_is-active"
                exact
                to="/meus-enderecos"
                className="perfil-menu-item-link "
              >
                Meus Endereços
              </NavLink>
            </S.ProfileMenuItem>
            <S.ProfileMenuItem className="perfil-menu-item">
              <NavLink
                activeClassName="_is-active"
                exact
                to="/meus-cartoes"
                className="perfil-menu-item-link "
              >
                Meus Cartões
              </NavLink>
            </S.ProfileMenuItem>
            {
              <S.ProfileMenuItem className="perfil-menu-item">
                <NavLink
                  activeClassName="_is-active"
                  exact
                  to="/gimplus"
                  className="perfil-menu-item-link"
                >
                  Gimplus
                </NavLink>
              </S.ProfileMenuItem>
            }
            <S.ProfileMenuItem className="perfil-menu-item">
              <NavLink
                activeClassName="_is-active"
                to="/negociacoes"
                className="perfil-menu-item-link"
              >
                Negociações
              </NavLink>
            </S.ProfileMenuItem>
            <S.ProfileMenuItem className="perfil-menu-item">
              <NavLink
                activeClassName="_is-active"
                to="/cotacoes"
                className="perfil-menu-item-link"
              >
                Cotações
              </NavLink>
            </S.ProfileMenuItem>

            {isPF() && isPromotor(user.codigoPromotor) === true ? (
              <S.ProfileMenuItem className="perfil-menu-item">
                <NavLink
                  activeClassName="_is-active"
                  exact
                  to="/vendas-promovidas"
                  className="perfil-menu-item-link"
                >
                  Vendas Promovidas
                </NavLink>
              </S.ProfileMenuItem>
            ) : null}

            {!isPF() && (
              <S.ProfileMenuItem className="perfil-menu-item">
                <a
                  href={`${process.env.REACT_APP_URL_MAIN}/boleto/lista`}
                  className="perfil-menu-item-link"
                >
                  2ª via de Boleto
                </a>
              </S.ProfileMenuItem>
            )}

            {!isPF() && !!user.permiteTrocarCliente ? (
              <S.ProfileMenuItem className="perfil-menu-item">
                <a
                  href={`${process.env.REACT_APP_URL_MAIN}/Checkout/SelecionarCadastro`}
                  className="perfil-menu-item-link"
                >
                  Trocar Cliente
                </a>
              </S.ProfileMenuItem>
            ) : null}

            {/* <S.ProfileMenuItem className="perfil-menu-item">
              <NavLink
                activeClassName="_is-active"
                exact
                to="/alterar-senha"
                className="perfil-menu-item-link"
              >
                Alterar Senha
              </NavLink>
            </S.ProfileMenuItem> */}
            <hr />

            <S.ProfileMenuItem className="perfil-menu-item">
              <a
                href={process.env.REACT_APP_URL_MAIN}
                className="perfil-menu-item-link"
              >
                Sair
              </a>
              {/* <NavLink
                exact
                to="#"
                className="perfil-menu-item-link"
                onClick={() =>
                  (window.location.href = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/logout`)
                }
              >
                Sair
              </NavLink> */}
            </S.ProfileMenuItem>
          </S.ProfileMenuList>
        </S.ProfileBox>
      </S.ProfileMenu>
    </S.Wrapper>
  )
}

export default ProfileSideMenu
